import { action } from "satcheljs";

/**
 * Action to toggle mute schedule group state.
 * Dispatched from UI when user clicks Mute Schedule Group / Unmute Schedule Group menu item.
 * Orchestrator handles fetch, update, save, and error handling.
 */
const toggleMuteScheduleGroup = action(
    "TOGGLE_MUTE_SCHEDULE_GROUP",
    (teamId: string, scheduleGroupId: string) => ({
        teamId,
        scheduleGroupId
    })
);

export default toggleMuteScheduleGroup;
